import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { ListTable } from 'gnos-tables'
import _ from 'lodash'

import Signals from '../../../../../../../../../../../../../../../../../components/TableCell/components/Signals'
import CellStyleWrapper from '../../../../../../../../../../../../../../../../../components/TableCell/components/CellStyleWrapper'
import Entity from '../../../../../../../../../../../../../../../../../components/TableCell/components/Entity'

import { LOCALE_PREFIX } from '../../../../../../../../constants'

import './styles.scss'

@injectIntl
export default class Suppliers extends Component {
    static propTypes = {
        data: PropTypes.array,
        id: PropTypes.string.isRequired,
        intl: PropTypes.object,
        tenderId: PropTypes.number.isRequired,
    }

    render() {
        const { data, id, tenderId, intl } = this.props

        return (
            <div className={'assigned-tenders-sub-table-suppliers-wrapper'}>
                <div className={'table-title'}>{intl.formatMessage({ id: `${LOCALE_PREFIX}.suppliers` })}</div>
                {_.isEmpty(data) && (
                    <div className={'no-list-table-data'}>
                        {intl.formatMessage({ id: `${LOCALE_PREFIX}.noSuppliers` })}
                    </div>
                )}
                <ListTable
                    id={`assigned-tenders-sub-table-suppliers-table-${id}-${tenderId}`}
                    itemIdentifier={'subject.id'}
                    staticData={{
                        _table: [
                            {
                                key: `assigned-tenders-sub-table-suppliers-table-${id}-${tenderId}`,
                                tables: [
                                    {
                                        rows: data,
                                    },
                                ],
                            },
                        ],
                    }}
                    texts={{
                        controlExpand: intl.formatMessage({ id: 'global.controlExpand' }),
                        controlMore: intl.formatMessage({ id: 'global.controlMore' }),
                        controlLess: intl.formatMessage({ id: 'global.controlLess' }),
                        controlAll: intl.formatMessage({ id: 'global.controlAll' }),
                        controlClose: intl.formatMessage({ id: 'global.controlClose' }),
                        controlFirst: intl.formatMessage({ id: 'global.controlFirst' }),
                    }}
                    columnsDefinition={{
                        title: {
                            Cell: () => (
                                <CellStyleWrapper isCentered>
                                    <span>{intl.formatMessage({ id: `${LOCALE_PREFIX}.supplier` })}</span>
                                </CellStyleWrapper>
                            ),
                            width: 100,
                        },
                        top: {
                            columns: [
                                {
                                    accessor: 'subject',
                                    Cell: ({ value, original }) => (
                                        <CellStyleWrapper isCentered>
                                            <Entity
                                                entity={value}
                                                value={value?.name}
                                                type={value?.type}
                                                inactive={value?.inactive}
                                                entId={value?.id}
                                                rowInactive={original?.inactive}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                },
                                {
                                    accessor: 'subject.indicators',
                                    Cell: ({ value, original }) => (
                                        <CellStyleWrapper isCentered>
                                            <Signals
                                                id={original?.subject?.id}
                                                notice={value?.notice}
                                                risk={value?.risk}
                                                caution={value?.caution}
                                            />
                                        </CellStyleWrapper>
                                    ),
                                    width: 150,
                                },
                            ],
                        },
                    }}
                />
            </div>
        )
    }
}
